var _path, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.372 4.228v16.535h-3.747l-5.974-8.688h-.097v8.688h-4.49V4.228h3.812l5.877 8.655h.13V4.228h4.489zM90.938 4.228v16.535h-3.746l-5.975-8.688h-.097v8.688h-4.489V4.228h3.811l5.878 8.655h.129V4.228h4.489zM74.555 12.494c0 1.84-.358 3.393-1.074 4.659-.716 1.259-1.682 2.214-2.899 2.866-1.216.646-2.573.969-4.069.969-1.507 0-2.869-.326-4.085-.977-1.211-.657-2.175-1.615-2.89-2.875-.711-1.265-1.066-2.812-1.066-4.642 0-1.841.355-3.391 1.065-4.65.716-1.266 1.68-2.221 2.89-2.867C63.645 4.326 65.007 4 66.514 4c1.496 0 2.853.326 4.07.977 1.216.646 2.182 1.601 2.898 2.866.716 1.26 1.074 2.81 1.074 4.65zm-4.619 0c0-.99-.132-1.825-.395-2.503-.259-.684-.644-1.2-1.155-1.55-.506-.356-1.13-.533-1.873-.533-.743 0-1.37.177-1.881.533-.506.35-.89.866-1.155 1.55-.258.678-.387 1.512-.387 2.503 0 .99.129 1.827.387 2.51.264.679.649 1.196 1.155 1.551.511.35 1.138.525 1.881.525.743 0 1.367-.175 1.873-.525.511-.355.896-.872 1.155-1.55.264-.684.395-1.52.395-2.511zM56.502 10.427h-4.554A3.087 3.087 0 0051.69 9.4a2.313 2.313 0 00-.566-.79 2.357 2.357 0 00-.863-.518 3.352 3.352 0 00-1.155-.185c-.754 0-1.391.183-1.913.549-.517.366-.91.89-1.18 1.574-.263.684-.395 1.505-.395 2.463 0 1.012.135 1.86.404 2.543.274.678.67 1.19 1.187 1.534.516.34 1.138.509 1.865.509.414 0 .786-.051 1.114-.154.328-.107.614-.26.856-.46.242-.199.439-.439.59-.718.155-.286.26-.606.314-.961l4.554.032c-.054.7-.25 1.413-.59 2.14a6.956 6.956 0 01-1.445 2.002c-.619.608-1.386 1.098-2.3 1.47-.916.37-1.979.557-3.19.557-1.518 0-2.88-.326-4.085-.977-1.2-.652-2.15-1.61-2.85-2.875C41.346 15.871 41 14.324 41 12.494c0-1.841.355-3.391 1.066-4.65.71-1.266 1.668-2.221 2.874-2.867C46.146 4.326 47.491 4 48.977 4c1.044 0 2.005.143 2.882.428a6.936 6.936 0 012.31 1.251 6.182 6.182 0 011.598 2.01c.404.797.649 1.71.735 2.738z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 31,
    height: 18,
    rx: 7,
    stroke: "url(#logo-dark_svg__paint0_linear_3457_3)",
    strokeOpacity: 0.9,
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-dark_svg__paint0_linear_3457_3",
    x1: 5.5,
    y1: 4.5,
    x2: 33.5,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B99"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    from: "0 0.5 0.5",
    to: "360 0.5 0.5",
    dur: "3s",
    repeatCount: "indefinite"
  })))));
}

export default SvgLogoDark;